import { z } from 'zod';

import { CompanyId, LosId, WorkflowDefinitionId, WorkflowInstanceId } from '../BrandedIds';
import { zodTemporalInstant } from '../Temporal';
import { zodBrandedString } from '../utils';

export const ExportableWorkflowInstance = z
  .object({
    id: WorkflowInstanceId,
    companyId: CompanyId,
    loanId: LosId,

    status: z.enum(['ACTIVE', 'COMPLETED', 'CANCELLED']),

    workflowDefinitionId: zodBrandedString<WorkflowDefinitionId>(),
    workflowDefinitionVersion: z.number(),

    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'WorkflowInstance' });

export type ExportableWorkflowInstance = z.infer<typeof ExportableWorkflowInstance>;
